export const CREATE_REMOCON_NAME = 'CREATE_REMOCON';
export const CREATE_BUTTON_NAME = 'CREATE_BUTTON';
export const CREATE_COMMAND_NAME = 'CREATE_COMMAND';
export const CREATE_SCHEDULE_NAME = 'CREATE_SCHEDULE';
export const CREATE_PROGRAM_NAME = 'CREATE_PROGRAM';

export const DAYS = [{
  code: 'SUN', name: '일'
}, {
  code: 'MON', name: '월'
}, {
  code: 'TUE', name: '화'
}, {
  code: 'WED', name: '수'
}, {
  code: 'THU', name: '목'
}, {
  code: 'FRI', name: '금'
}, {
  code: 'SAT', name: '토'
}];

export const HOURS = Array.from(Array(24).keys()).map(k => k);
export const TIMES = Array.from(Array(60).keys()).map(k => k);
export const ADD_DEVICE_NAME = 'ADD_DEVICE';

export const EVENT_TYPES = [
  { value: 'entranceControl', text: '출입구관제' },
  { value: 'fullControl', text: '전체관제' },
  { value: 'controlEnd', text: '관제종료' }
];

export const CONTROL_ACTION = {
  entrance: {code: 'entrance', text: '출입구관제'},
  full: {code: 'full', text: '전체관제'},
  end: {code: 'end', text: '관제종료'},
};
